import styled from "styled-components";

export const SDashboard = styled.div`
  position: absolute;
  visibility: ${(props) => (props.visible ? "visible" : "hidden")};

  display: flex !important;
  flex-direction: column;
  overflow-y: scroll;

  padding: 1rem;
  background-color: rgb(var(--primary-light-rgb), 1);

  z-index: 2;

  transition: all 0.2s ease-in-out;

  @media (min-width: 768px) {
    right: var(--sidebar-width) ${(props) => props.sidePanelVisible && "+  var(--panel-width)"};
    width: calc(100% - var(--sidebar-width) ${(props) => props.sidePanelVisible && "- var(--panel-width)"});
    height: 100vh !important;
    overflow: hidden;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: calc(100vh - 5rem);
  }

  .title-section {
    @media (min-width: 768px) {
      height: 10%;
    }

    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: center;
    color: var(--text-primary-light);
  }

  h3 {
    font-style: italic;
    color: var(--text-primary-light);
  }

  .change-stats {
    position: absolute;
    right: 1rem;
    top: 1rem;
  }

  .live-dashboard {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    @media (min-width: 768px) {
      height: 90%;
    }

    .monitor {
      display: flex;
      flex-direction: column;

      height: 70% !important;
    }

    .rest {
      height: 30% !important;

      .donut-description {
        height: 100%;

        @media (min-width: 768px) {
          width: 20%;
        }

        @media (max-width: 768px) {
          width: 70%;
        }
      }

      .donut-chart {
        height: 100%;
        width: 30%;
      }
    }
  }

  .async-dashboard {
    flex-grow: 1;
    padding-top: 1rem;
  }
  .feedback-chart {
    flex-grow: 1;
  }
`;

export const InfoCard = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  background-color: var(--primary-dark);
  color: var(--text-primary-dark);
  border-radius: 99em;
  padding: 0.6rem 2rem;
  margin-top: 0.5rem;

  .number {
    font-size: 1.6rem;
  }

  .title {
    font-size: 1rem;
  }

  .icon {
    transform: scale(3);
    margin-right: 1rem;
  }
`;

/* export const Questions = styled.div`
  margin-top: 1rem;

  .title {
    text-align: center;
  }

  .question {
    flex-grow: 1;
    margin: auto 1rem;
    padding: 0.5rem;
    text-align: center;
  }

  .arrow-active {
    color: rgba(var(--text-primary-light-rgb), 1);
  }

  .arrow-disabled {
    color: rgba(var(--text-primary-light-rgb), 0.3);
  }
`; */
